import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="514 680 535 684 535 693.37 602 707 602 711.93 946 779 946 788.98 1194 839 1219 824 1353 849 1368 839 1427 850 1449 831 1449 848.64 1351 935 517 732 514 680"
      />
      <polygon
        data-floor="1"
        points="514 680 535 684 535 693.37 602 707 602 711.93 946 779 946 788.98 1194 839 1219 824 1353 849 1368 839 1427 850 1449 831 1510 777 1510 761.1 1529 746 1530 713 1534 710 1500 705 1431 753 1372 745 1358 753 1221 733 1195 744 946 704 946 697 602 643 602 639 532 629 532 624 512 623 514 680"
      />
      <polygon
        data-floor="2"
        points="512 623 532 624 532 629 602 639 602 643 946 697 946 704 1195 744 1221 733 1358 753 1372 745 1431 753 1500 705 1513 695 1513 684.53 1533 668 1534 635.97 1536 635 1536 632.23 1495 630 1495 624 1433 655 1373 649 1360 654 1222 640 1197 648 946 619 946 614 600 574 600 571 530 563 530 559 509 557 510.8 623 512 623"
      />
      <polygon
        data-floor="3"
        points="509 557 530 559 530 563 600 571 600 574 946 614 946 619 1197 648 1222 640 1360 654 1373 649 1433 655 1495 624 1518 610 1518 600.29 1536 592.1 1536 555.38 1498 554 1498 536 1438 555 1377 552 1363 556 1223 546 1200 551 944.99 533 945 529 597 505 597 502 528 497 528 494 507 493 507 518.89 503 519 504 550 508 550 507.86 557 509 557"
      />
      <polygon
        data-floor="4"
        points="507 493 528 494 528 497 597 502 597 505 945 529 944.99 533 1200 551 1223 546 1363 556 1377 552 1438 555 1498 536 1520 528 1520 522.16 1542 515 1542 478.35 1501 478 1501 446 1440 454 1380 453 1366 454 1225 451 1200 452 944 445 944 443 595 434 595 432 523 430 523 427 504 426 507 493"
      />
      <polygon
        data-floor="5"
        points="504 426 523 427 523 430 595 432 595 434 896.3 441.77 944 443 944 445 1200 452 1225 451 1366 454 1380 453 1440 454 1501 446 1523 443 1523 440 1544 438 1544 400.13 1504.11 400.13 1504 360 1542 360 1443 352 1384 353 1369 353 1227 354 1201 353 832 358 521 363 521 360 502 360 504 426"
      />
      <polygon
        data-floor="6"
        points="502 360 521 360 521 363 968.36 356.15 1201 353 1227 354 1369 353 1443 352 1542 360 1548 360 1548 321 1536 320 1536 314 1507 312 1507 282 1548 280.14 1514 271 1528 269 1449 248 1386 251 1373 251 1231 256 1205 252 947 266 958 269 521 295 501 295 502 360"
      />
      <polygon
        data-floor="7"
        points="501 295 521 295 590.08 290.89 732.37 282.42 958 269 947 266 1205 252 1231 256 1373 251 1449 248 1528 269 1514 271 1548 280.14 1552 280 1552 240.66 1534 234 1534 227 1511 219 1511 208 1551 205 1551 203 1516 190 1516 188 1531.73 188 1532 184 1452 145 1412 148 1377 134 1205 150 1176 143 1176 123 1178.92 123 1179 121 1169.11 121 1169 112 1172.25 112 1172 109 1160 106 1136 110 1136 99 1126 96 1088 102 1088 112 1076 112 1044 102 659 152 660 213 496 230 501 295"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
